import type React from 'react';
import { Link } from 'react-router-dom';
import { buttonStyles } from '../tailgrids/core/button.js';
import { cn } from '../../utils/cn.js';
import { SubmitButton } from './Form.js';

interface FormActionsProps {
  /** The submit button's label ("Save changes", "Create task"). */
  submitLabel: string;
  /** Cancel as a link to where the person came from. */
  cancelTo?: string;
  /** Cancel as a click handler (reset the form, close a section). Give one of `cancelTo` or `onCancel`. */
  onCancel?: () => void;
  cancelLabel?: string;
  /** Extra controls before Cancel (Save draft). */
  children?: React.ReactNode;
  className?: string;
}

const CANCEL = { variant: 'primary', appearance: 'outline', size: 'lg', className: 'px-3.5 text-sm' } as const;

/**
 * The form footer: Cancel (outline) and the submit button, right aligned, `lg`. Template example: NextAdmin
 * `profile/account/page.tsx` (`col-span-1 flex items-center justify-end gap-3 md:col-span-2`) and demo `/form-layouts`.
 */
export function FormActions({
  submitLabel,
  cancelTo,
  onCancel,
  cancelLabel = 'Cancel',
  children,
  className,
}: FormActionsProps) {
  return (
    <div className={cn('col-span-1 flex items-center justify-end gap-3 md:col-span-2', className)}>
      {children}
      {cancelTo !== undefined && (
        <Link to={cancelTo} className={buttonStyles(CANCEL)}>
          {cancelLabel}
        </Link>
      )}
      {cancelTo === undefined && onCancel && (
        <button type="button" onClick={onCancel} className={buttonStyles(CANCEL)}>
          {cancelLabel}
        </button>
      )}
      <SubmitButton variant="primary" size="lg" className="px-3.5 text-sm">
        {submitLabel}
      </SubmitButton>
    </div>
  );
}
